module.exports = __webpack_public_path__ + "img/avatar.5d0f04b8.png";